import { render, staticRenderFns } from "./CommonClaimReportCard.vue?vue&type=template&id=1effa126"
import script from "./CommonClaimReportCard.vue?vue&type=script&lang=js"
export * from "./CommonClaimReportCard.vue?vue&type=script&lang=js"
import style0 from "./CommonClaimReportCard.vue?vue&type=style&index=0&id=1effa126&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports